/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'

import { checkErrorResponse, Logger, LoggerTypes } from '../../../../../utils'
import { DialogFormEdit } from '../../../../../components'
import { AttributeProductForm } from '../../AttributeProductForm'

export const AttributeProductDialogCreate = ({
  currentProject,
  currentScenario,
  openDialog,
  setOpenDialog,
  actionCreateDispatch
}) => {
  const [errors, setErrors] = useState(null)

  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const title = currentScenario
    ? t('attributes.products.create.scenario')
    : currentProject
    ? t('attributes.products.create.project')
    : t('attributes.products.create.global')

  /**
   * Action received from the Product Form.
   * @see <AttributeProductForm />
   *
   * @param {object} newProduct New Product's attribute object to create.
   * @param {string} newProductId here it's null but will be the product's attribute UUID in case of update
   * @param {func} onSuccess Function to execute on success.
   */
  const onDispatchAction = (newProduct, newProductId, onSuccess) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'AttributeProductDialogCreate.onDispatchAction()', {
      newProduct,
      newProductId
    })

    if (actionCreateDispatch) {
      dispatch(actionCreateDispatch(newProduct, currentProject?.id, currentScenario?.id))
        .then((res) => {
          Logger.trace(
            LoggerTypes.CONTROLLER,
            'AttributeProductDialogCreate.onDispatchAction().dispatch(actionCreateDispatch(...)).then()',
            {
              res,
              onSuccess
            }
          )

          if (onSuccess && typeof onSuccess === 'function') {
            onSuccess(res)
          }
        })
        .catch((res) => {
          Logger.trace(
            LoggerTypes.WARN,
            'AttributeProductDialogCreate.onDispatchAction().dispatch(actionCreateDispatch(...)).catch()',
            {
              res
            }
          )

          if (res?.response?.data) {
            checkErrorResponse(res, enqueueSnackbar, t)

            const _data = res?.response?.data || null
            if (_data && (_data?.fields || _data?.error)) {
              let _error = _data?.fields || {}
              if (_data?.error) {
                _error.generic = _data.error
              }
              setErrors(_error)
            }
          }
        })
    } else {
      Logger.trace(LoggerTypes.WARN, 'AttributeProductDialogCreate.onDispatchAction().catch()', {
        currentProject,
        currentScenario,
        actionCreateDispatch
      })
    }
  }

  Logger.trace(LoggerTypes.CONTAINER, 'AttributeProductDialogCreate.render()', {
    currentProject,
    currentScenario
  })

  return (
    <DialogFormEdit className="attribute-form" openDialog={openDialog} setOpenDialog={setOpenDialog}>
      <AttributeProductForm
        title={title}
        setOpenDialog={setOpenDialog}
        dispatchAction={onDispatchAction}
        errors={errors}
      />
    </DialogFormEdit>
  )
}

AttributeProductDialogCreate.displayName = 'AttributeProductDialogCreate'

AttributeProductDialogCreate.propTypes = {
  currentProject: PropTypes.object,
  currentScenario: PropTypes.object,
  openDialog: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired,
  actionCreateDispatch: PropTypes.func.isRequired
}

AttributeProductDialogCreate.defaultProps = {
  currentProject: null,
  currentScenario: null,
  openDialog: false,
  setOpenDialog: () => {},
  actionCreateDispatch: null
}
